export default "__VITE_ASSET__DbPnK4cM__"